import { ExternalNavigationNavigateParams, ExternalNavigationService } from './ExternalNavigation.service';

export class BrowserNavigationService implements ExternalNavigationService {
  public navigate = (url: string, params?: ExternalNavigationNavigateParams): void => {
    const target = params ? params.target : undefined;
    window.open(url, target);
  };
}
